export default () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            opacity="1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.06429 10.0473H10.0514V15.3673C10.0514 16.7891 8.87766 17.9528 7.44347 17.9528H6.06429C3.86348 17.9528 2.07715 16.1818 2.07715 14C2.07715 11.8182 3.86348 10.0473 6.06429 10.0473Z"
            fill="#5799F1"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1711 10.0473C17.7836 9.44003 18.0257 8.63276 18.0257 7.75639V6.09457C18.0257 3.91275 16.2394 2.14185 14.0386 2.14185C11.8378 2.14185 10.0514 3.91275 10.0514 6.09457V15.3673C10.0514 16.7891 8.87768 17.9528 7.44348 17.9528H7.74059C8.71262 17.9528 9.5526 17.6073 10.2422 16.9237L17.1674 10.0473H17.1711Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0128 17.9528H18.0257V12.4037C18.0257 11.1091 19.0968 10.0473 20.4026 10.0473H22.0128C24.2137 10.0473 26 11.8182 26 14C26 16.1818 24.2137 17.9528 22.0128 17.9528Z"
            fill="white"
        />
        <path
            opacity="1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9098 17.9528C10.2972 18.56 10.0551 19.3637 10.0551 20.24V21.9055C10.0551 24.0873 11.8414 25.8582 14.0423 25.8582C16.2431 25.8582 18.0294 24.0873 18.0294 21.9055V12.6328C18.0294 11.2109 19.2032 10.0473 20.6374 10.0473H20.3403C19.3646 10.0473 18.5246 10.3928 17.835 11.0764L10.9098 17.9528Z"
            fill="#5799F1"
        />
        <path
            d="M14.0276 23.7346C14.7589 23.7346 15.3517 23.1468 15.3517 22.4219C15.3517 21.6969 14.7589 21.1091 14.0276 21.1091C13.2963 21.1091 12.7034 21.6969 12.7034 22.4219C12.7034 23.1468 13.2963 23.7346 14.0276 23.7346Z"
            fill="#003366"
        />
        <path
            d="M22.5338 15.3128C23.2651 15.3128 23.8579 14.725 23.8579 14C23.8579 13.275 23.2651 12.6873 22.5338 12.6873C21.8024 12.6873 21.2096 13.275 21.2096 14C21.2096 14.725 21.8024 15.3128 22.5338 15.3128Z"
            fill="#003366"
        />
    </svg>
);
